import ReactDOM from 'react-dom';
// Ensure shared modal host is mounted and window.JkitOpenPricingModal is available
import '../shared/modal-host';
import WizardPage from './components/wizard';

const SELECTOR = 'a.upgrade, .button-upgrade-pro, .button-upgrade, .upgrade-pro-btn, .jkit-upgrade-to-pro-menu a, #wp-admin-bar-jeg-kit-pro, .jkit-upgrade-banner .jkit-banner-cta-button-wrapper .jkit-banner-cta-button, .f-button-upgrade, #jkit-onboard-wizard .upgrade-pro-button, #jkit-onboard-wizard .f-button-upgrade';

const handleUpgradeClick = (e) => {
    const el = e.target.closest && e.target.closest(SELECTOR);
    if (!el) return;

    try {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    } catch (err) {
        // ignore
    }

    if (typeof window.JkitOpenPricingModal === 'function') {
        window.JkitOpenPricingModal();
        return;
    }

    // Try safe opener (will mount host if needed). If safe opener not available, fallback to opening admin page.
    const href = (el.getAttribute && el.getAttribute('href')) || (window.jkitWizard?.adminUrl ? window.jkitWizard.adminUrl + 'admin.php?page=jkit' : window.location.origin + '/wp-admin/admin.php?page=jkit');

    if (typeof window.JkitOpenPricingModalSafe === 'function') {
        // call safe opener; if it fails, open fallback (may be blocked by popup blocker)
        window.JkitOpenPricingModalSafe().then((opened) => {
            if (!opened) {
                try { window.open(href, '_blank'); } catch (e) {}
            }
        });
        return;
    }

    try { window.open(href, '_blank'); } catch (e) {}
};

const attachListeners = () => {
    if (window.__jkit_wizard_upgrade_listeners_attached) return;
    document.addEventListener('click', handleUpgradeClick, true);
    document.addEventListener('auxclick', handleUpgradeClick, true);
    window.__jkit_wizard_upgrade_listeners_attached = true;
};

const detachListeners = () => {
    if (!window.__jkit_wizard_upgrade_listeners_attached) return;
    document.removeEventListener('click', handleUpgradeClick, true);
    document.removeEventListener('auxclick', handleUpgradeClick, true);
    try { delete window.__jkit_wizard_upgrade_listeners_attached; } catch (e) { window.__jkit_wizard_upgrade_listeners_attached = false; }
};

const loadWizard = () => {
    const onboardWizardDiv = document.getElementById('jkit-onboard-wizard');

    if (onboardWizardDiv) {
         ReactDOM.render(
            <WizardPage/>,
            onboardWizardDiv
        );
    }
};

window.addEventListener('load', () => {
    loadWizard();
    attachListeners();
});

window.addEventListener('unload', () => {
    detachListeners();
});
